module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_6-cfcb9c2fbc8caf4bf6b6d1da97068ad1.png";